import moment from 'moment'
// import 'moment/locale/ar'
import 'moment/locale/fr'
import 'moment/locale/tr'
import 'moment/locale/ur'
import {FC, createContext, useContext} from 'react'
import {setLocale} from 'yup'

import {WithChildren} from '../helpers'
import yupArLocale from './yupLocale/ar'
import yupEngLocale from './yupLocale/en'
import yupFrLocale from './yupLocale/fr'
import yupTrLocale from './yupLocale/tr'
import yupUrLocale from './yupLocale/ur'

const I18N_CONFIG_KEY = import.meta.env.VITE_APP_I18N_CONFIG_KEY || 'i18nConfig'

type LangOption = 'ar' | 'en' | 'fr' | 'tr' | 'ur'
type Props = {
  selectedLang: LangOption
}
const initialState: Props = {
  selectedLang: 'en',
}

export function getLang(): Props {
  const ls = localStorage.getItem(I18N_CONFIG_KEY)
  if (ls) {
    try {
      return JSON.parse(ls) as Props
    } catch (er) {
      console.error(er)
    }
  }
  return initialState
}

// Side effect
export function setLanguage(lang: string) {
  localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: lang}))
  window.location.reload()
}

const I18nContext = createContext<Props>(initialState)

const useLang = () => {
  return useContext(I18nContext).selectedLang
}

export function isRtl() {
  const rtlLangs = ['ar', 'ur']
  const lang = getLang().selectedLang
  return rtlLangs.includes(lang)
}

export const getYupLocale = (lang: LangOption) => {
  switch (lang) {
    case 'ar':
      return yupArLocale
    case 'en':
      return yupEngLocale
    case 'fr':
      return yupFrLocale
    case 'tr':
      return yupTrLocale
    case 'ur':
      return yupUrLocale

    default:
      return yupEngLocale
  }
}

const MetronicI18nProvider: FC<WithChildren> = ({children}) => {
  const lang = getLang()
  const yupLocale = getYupLocale(lang.selectedLang)
  const momentLocale = lang.selectedLang === 'ar' ? 'en' : lang.selectedLang
  moment.locale(momentLocale)
  setLocale(yupLocale)
  return <I18nContext.Provider value={lang}>{children}</I18nContext.Provider>
}

export {MetronicI18nProvider, useLang}
